export const LOAD_QVCT_ANSWER_TYPE = 'LOAD_QVCT_ANSWER_TYPE'